import React from "react";

export default function HomePage() {
  return (
    <div className="min-h-screen flex flex-col text-white bg-[linear-gradient(180deg,var(--bg-start)_0%,#0B2E5B_50%,var(--bg-end)_100%)]">
      
      {/* HERO */}
      <header className="text-center pt-6 pb-4">
        <h1 className="text-3xl md:text-4xl font-extrabold mb-4">
          ⚡ Trenton Thunder Player Analysis Platform
        </h1>
        <p className="max-w-4xl mx-auto text-lg text-white/80 mb-4 px-4">
          Comprehensive player evaluation system integrating advanced metrics, scouting insight, and developmental tracking to support decision-making at the professional level.
        </p>

        {/* Season pill */}
        <div className="mb-4">
          <span className="inline-flex items-center rounded-full px-6 py-2 font-semibold shadow-md
                           bg-[#f5c518] text-[#0B2E5B]">
            2025 SEASON
          </span>
        </div>
      </header>

      {/* CARDS GRID - Professional Analytics Showcase */}
      <main className="px-4 pb-6 flex-1 flex flex-col justify-start mt-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-5xl mx-auto mb-6">
          {/* Pitching Analysis - Complete Analytics Suite */}
          <section className="rounded-2xl bg-slate-800 p-6 shadow-xl">
            <h3 className="text-xl font-bold mb-4 text-white">⚡&nbsp;Pitching Analysis</h3>
            <ul className="space-y-3 text-white/90">
              <li>— Featured Pitchers</li>
              <li>— Pitcher Scouting Reports</li>
              <li>— Pitch Type Analysis</li>
              <li>— Featured Pitcher Dev Notes</li>
            </ul>
          </section>

          {/* Hitting Analysis - Complete Analytics Suite */}
          <section className="rounded-2xl bg-slate-800 p-6 shadow-xl">
            <h3 className="text-xl font-bold mb-4 text-white">⚡&nbsp;Hitting Analysis</h3>
            <ul className="space-y-3 text-white/90">
              <li>— Featured Hitters</li>
              <li>— Hitter Scouting Reports</li>
              <li>— Hitter Spray Profiles</li>
              <li>— Featured Hitter Dev Notes</li>
            </ul>
          </section>
        </div>
        
        {/* Footer */}
        <footer className="text-center text-sm text-white/60 py-4 px-8 bg-black/20 rounded-lg max-w-6xl mx-auto">
          © 2025 Chris Behan — Designed & Built for Professional Baseball Operations
        </footer>
      </main>
    </div>
  );
}
